exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".edit-delivery-type li.list-item {\n  margin-top: 10px; }\n  .edit-delivery-type li.list-item label {\n    font-size: 1rem; }\n\n.dialog-delivery_types {\n  min-width: 300px;\n  min-height: 200px; }\n  .dialog-delivery_types .w-50 {\n    width: 50%; }\n  .dialog-delivery_types .text-right {\n    text-align: right; }\n\n@media only screen and (max-width: 767px) {\n  .delivery-dialog-paper {\n    min-width: 250px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/delivery/AddEdit/index.scss
// module id = 1552
// module chunks = 0